// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: rTUZrYoyBZ
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import BtnText from "../../BtnText"; // plasmic-import: R3LXVa6EIz/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "../blank_project/plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicSaveModal.module.css"; // plasmic-import: rTUZrYoyBZ/css
import Icon12Icon from "./icons/PlasmicIcon__Icon12"; // plasmic-import: LYoK9OD3Rv/icon

createPlasmicElementProxy;

export const PlasmicSaveModal__VariantProps = new Array();

export const PlasmicSaveModal__ArgProps = new Array();

const $$ = {};

function PlasmicSaveModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__eAxwj)}>
        <div className={classNames(projectcss.all, sty.freeBox__pCl74)}>
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"Status"}
          </div>
          <Icon12Icon
            data-plasmic-name={"btnClose"}
            data-plasmic-override={overrides.btnClose}
            className={classNames(projectcss.all, sty.btnClose)}
            role={"img"}
          />
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__y0DXw)}>
          <div
            data-plasmic-name={"error"}
            data-plasmic-override={overrides.error}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.error
            )}
          >
            {"Please set the status of this component"}
          </div>
          <Stack__
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__vA2OS)}
          >
            <BtnText
              data-plasmic-name={"btnNotStarted"}
              data-plasmic-override={overrides.btnNotStarted}
              className={classNames("__wab_instance", sty.btnNotStarted)}
              red={true}
            >
              {"Not Started"}
            </BtnText>
            <BtnText
              data-plasmic-name={"btnInProgress"}
              data-plasmic-override={overrides.btnInProgress}
              blue={true}
              className={classNames("__wab_instance", sty.btnInProgress)}
            >
              {"In Progress"}
            </BtnText>
            <BtnText
              data-plasmic-name={"btnComplete"}
              data-plasmic-override={overrides.btnComplete}
              className={classNames("__wab_instance", sty.btnComplete)}
              green={true}
            >
              {"Complete"}
            </BtnText>
          </Stack__>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "text",
    "btnClose",
    "error",
    "btnNotStarted",
    "btnInProgress",
    "btnComplete"
  ],

  text: ["text"],
  btnClose: ["btnClose"],
  error: ["error"],
  btnNotStarted: ["btnNotStarted"],
  btnInProgress: ["btnInProgress"],
  btnComplete: ["btnComplete"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSaveModal__ArgProps,
          internalVariantPropNames: PlasmicSaveModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSaveModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSaveModal";
  } else {
    func.displayName = `PlasmicSaveModal.${nodeName}`;
  }
  return func;
}

export const PlasmicSaveModal = Object.assign(
  // Top-level PlasmicSaveModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    btnClose: makeNodeComponent("btnClose"),
    error: makeNodeComponent("error"),
    btnNotStarted: makeNodeComponent("btnNotStarted"),
    btnInProgress: makeNodeComponent("btnInProgress"),
    btnComplete: makeNodeComponent("btnComplete"),
    // Metadata about props expected for PlasmicSaveModal
    internalVariantProps: PlasmicSaveModal__VariantProps,
    internalArgProps: PlasmicSaveModal__ArgProps
  }
);

export default PlasmicSaveModal;
/* prettier-ignore-end */
